import React from 'react';
import { useLang } from '../context/LanguageContext';
import { PageHeader } from '../components/PageHeader';
import ContactStrip from '../components/ContactStrip';
import LegalBody from '../components/LegalBody';
import SEO from '../components/SEO';
import { getSeo, SEO_KEYWORDS } from '../data/seo';
import { PRIVACY } from '../data/legal';

// Privacy policy — final client-provided German version (legally binding).
// English is a convenience translation; the German version prevails.
const Datenschutz = () => {
  const { lang } = useLang();
  const seo = getSeo('datenschutz', lang);
  return (
    <div>
      <SEO title={seo.title} description={seo.description} path="/datenschutz" lang={lang} keywords={SEO_KEYWORDS[lang]} />
      <PageHeader label={lang === 'de' ? 'Datenschutz' : 'Privacy'} title={lang === 'de' ? 'Datenschutzerklärung' : 'Privacy Policy'} />
      <section className="bg-white py-16 lg:py-24">
        <div className="container-wide max-w-3xl" data-testid="datenschutz-content">
          {lang === 'en' && (
            <p className="mb-8 text-[13px] text-slate-500 italic">Convenience translation — the legally binding version of this privacy policy is the German one.</p>
          )}
          <LegalBody blocks={lang === 'de' ? PRIVACY.de : PRIVACY.en} />
        </div>
      </section>
      <ContactStrip />
    </div>
  );
};

export default Datenschutz;
